import { routerReducer as routing } from 'react-router-redux'
import { combineReducers } from 'redux'
import { createResponsiveStateReducer } from 'redux-responsive'

import core from './core'
import errorMessage from './errorMessage'
import paused from './paused'
import waiting from './waiting'
import api from './api'
import coach from './coach'

export default combineReducers({
  browser: createResponsiveStateReducer({
    extraSmall: 575,
    small: 768,
    medium: 991,
    large: 1199
  }),
  core,
  errorMessage,
  paused,
  routing,
  waiting,
  api,
  coach
})
